import React from 'react'
import useBedbankPackageViews from 'hooks/useBedbankPackageViews'
import type { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import BedbankMobileStickyHeaderFilters from '../BedbankMobileStickyHeaderFilters'
import BedbankRoomOptionsMobile from '../BedbankRoomOptionsMobile'

interface Props {
  offer: App.BedbankOffer
  selectedBedbankRoomId: string
  onClose: () => void
  onBack?: () => void
}

function BedbankPackageSelectionModal(props: Props) {
  const {
    selectedBedbankRoomId,
    offer,
    onClose,
    onBack,
  } = props

  const [packageViews, fetchingRates] = useBedbankPackageViews(offer)

  return (
    <>
      <ModalHeader
        title="Select a package"
        onCloseButtonClick={onClose}
        onBackButtonClick={onBack}
      >
        <BedbankMobileStickyHeaderFilters />
      </ModalHeader>
      <ModalBody>
        <BedbankRoomOptionsMobile
          packageViews={packageViews}
          fetchingRates={fetchingRates}
          offer={offer}
          topPackageId={selectedBedbankRoomId}
        />
      </ModalBody>
    </>
  )
}

export default withOfferPageAndReduxState((state: OfferPageState) => ({
  selectedBedbankRoomId: state.selectedBedbankRoomId,
  offer: state.bedbankOffer!,
}), BedbankPackageSelectionModal)
